var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tips",style:(("display: " + (_vm.isShow ? 'block' : 'none')))},[_c('p',[_vm._v(_vm._s(_vm._f("showMsg")(_vm.state)))])])}
var staticRenderFns = []

export { render, staticRenderFns }